import type { ReactElement } from 'react';
import styles from './ProgressBar.module.scss';

/** Полоса прогресса; value — доля от 0 до 1. */
export function ProgressBar({ value, label }: { value: number; label: string }): ReactElement {
  const percent = Math.round(Math.min(1, Math.max(0, value)) * 100);
  return (
    <div className={styles.progress} role="progressbar" aria-label={label} aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
      {/* Ширина — значение из данных, а не стиль. */}
      <div className={styles.bar} style={{ width: `${percent}%` }} />
    </div>
  );
}
